// extracted by mini-css-extract-plugin
export default {"swiper_container":"Carousel_swiper_container__tdnpl","slide_item":"Carousel_slide_item__hrSs0","slide_text_content":"Carousel_slide_text_content__JuhrC"};